import { FlowRunStatuses, NodeRunState } from '@ply-io/runner';

import { runAllTrackingEvents } from './tracking-event-runner';
import { FLOW_RUNNER_END_RUN_ACTION_TYPES } from '@/components/BlockEditorWidget/FieldSettings/EndRunButtonsFieldSettings/end-run-field.const.js';
import { capitalizeWord } from '@/utils/language-service';

export function setTitle() {
	return 'Ply';
}

/* commented in 2022-08-17 becuase for now we don't want to expose the module title
export function setTitle(text) {
	const title = `Ply - ${text}`;
	try {
		document.title = title;
	} catch (e) {
		console.log(`Unable to set title ${title}`);
	}
}
*/

export function endRunBehaviour(
	action: string,
	endRunData: unknown,
	setMessage: (msg: string) => void,
	openWidget: (widgetData: unknown) => void
) {
	// @ts-ignore
	const { output } = endRunData;

	switch (action) {
		case FLOW_RUNNER_END_RUN_ACTION_TYPES.OPEN_URL: {
			const currentUrlParams = new URL(document.location.href).searchParams;
			const url = new URL(output.url);
			if (output.parameter_passthrough) {
				currentUrlParams.forEach((param, key) => url.searchParams.set(key, param));
			}
			// @ts-ignore
			const inNewTab = endRunData.open_url_in === 'new_tab';
			if (inNewTab) {
				window.open(url, '_blank');
			} else {
				window.location.href = url.toString();
			}
			break;
		}
		case FLOW_RUNNER_END_RUN_ACTION_TYPES.DISPLAY_MESSAGE:
			setMessage(output.message || 'Success');
			break;
		case FLOW_RUNNER_END_RUN_ACTION_TYPES.DISPLAY_INTERFACE:
			openWidget(endRunData);
			break;
		case FLOW_RUNNER_END_RUN_ACTION_TYPES.CLOSE_TAB:
			// window.close(``, `_parent`, ``);
			break;
	}
}

function isFlowRunStatusRunning(status: FlowRunStatuses) {
	return [FlowRunStatuses.Started, FlowRunStatuses.NotifSent, FlowRunStatuses.NotifResumed].includes(status);
}

export function buildStatusLabel(status: FlowRunStatuses) {
	let label: string = status;
	if (isFlowRunStatusRunning(status)) {
		label = 'running';
	}
	return capitalizeWord(label);
}

export function handleDoneNodeRun(nodeRun: NodeRunState) {
	if (nodeRun.data?.output && nodeRun.data?.output?.browserAction) {
		const renderData = nodeRun.data || {};
		const { output } = renderData;
		if (output.browserAction === 'copy') {
			// @ts-ignore
			navigator.clipboard.writeText(output.output);
		}
		if (output.browserAction === 'redirectToURL') {
			// @ts-ignore
			window.location.href = output.output;
		}
		if (output.browserAction === 'track' && nodeRun.serviceSlug === 'ply-tracking-events') {
			runAllTrackingEvents(output.output);
		}
	}
}

export function showFlowRunPercentage(status: FlowRunStatuses) {
	return isFlowRunStatusRunning(status);
}
